require("./legend");

require("./legend/ScrollableLegendModel");

require("./legend/ScrollableLegendView");

require("./legend/scrollableLegendAction");


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/legendScroll.js
// module id = P7ry
// module chunks = 0 1